import { getApplicationConfig } from "@/modules/app/utils/get-configuration";

export enum LICENSE_MODULE {
  EXPLORER = "explorer",
  TRACKER = "tracker",
  ANALYST = "analyst",
  PROCESSOR = "processor",
  ARRAY = "array",
}

export async function hasLicense(license: LICENSE_MODULE): Promise<boolean> {
  const configuration = await getApplicationConfig();

  return !!configuration?.modules?.includes(license);
}
